var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../../components/UnlinkedApplicationForm";
import { AutoEntity, saveAutoEntity, } from "../../../../../features/unlinked-application/unlinkedApplicationSlice";
import { Button, Radio } from "@savvyinsure/react-ui";
import AppBody from "../../../../../components/AppBody";
import Header from "../../../../../components/Header";
import { PHASE } from "../../../../../routeConfig";
import VehicleBreadcrumbs from "../../../../../features/unlinked-application/components/VehicleBreadcrumbs";
import { completedPage } from "../../../../../lib/Avo";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import useMemoryHistory from "../../../../../hooks/useMemoryHistory";
import { useParams } from "react-router-dom";
var options = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];
export default function UnlinkedApplicationAutoVehiclesFullCoverage() {
    var vehicleId = useParams().vehicleId;
    var vehicleToEdit = useAppSelector(function (state) {
        return state.unlinkedApplication.auto.vehicles.find(function (veh) { return veh.id === vehicleId; });
    });
    var defaultFullCoverage = typeof (vehicleToEdit === null || vehicleToEdit === void 0 ? void 0 : vehicleToEdit.fullCoverage) === "boolean"
        ? (vehicleToEdit === null || vehicleToEdit === void 0 ? void 0 : vehicleToEdit.fullCoverage)
            ? "true"
            : "false"
        : undefined;
    var _a = useForm({
        mode: "all",
        defaultValues: {
            fullCoverage: defaultFullCoverage,
        },
    }), handleSubmit = _a.handleSubmit, register = _a.register, isValid = _a.formState.isValid;
    var dispatch = useAppDispatch();
    var push = useMemoryHistory().push;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = register("fullCoverage", {
        required: true,
    }), onChange = _b.onChange, rest = __rest(_b, ["onChange"]);
    var onSubmit = handleSubmit(function (data) {
        if (!vehicleId) {
            throw new Error("Error while saving full coverage: missing vehicle id");
        }
        var fullCoverage = data.fullCoverage === "true";
        var selectedOption = "".concat(fullCoverage);
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        dispatch(saveAutoEntity({
            entity: AutoEntity.Vehicle,
            data: { id: vehicleId, fullCoverage: fullCoverage },
        }));
        push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", onSubmit: onSubmit, className: "p-6" },
            React.createElement(VehicleBreadcrumbs, { vehicle: vehicleToEdit }),
            React.createElement(UnlinkedApplicationForm.Header, null, "Would you like to include full coverage?"),
            React.createElement("p", { className: "mt-1 text-sm text-black-300" }, "Full coverage pays to repair or replace your vehicle in a variety of circumstances."),
            React.createElement("div", { className: "my-6 space-y-2" }, options.map(function (_a) {
                var label = _a.label, value = _a.value;
                return (React.createElement(Radio, __assign({ label: label, value: "".concat(value), key: label }, rest, { onChange: function (ev) {
                        onChange(ev);
                        setTimeout(function () { return onSubmit(); });
                    }, variant: "contained" })));
            })),
            React.createElement(Button, { disabled: !isValid }, "Continue"))));
}
